(function() {
  var switchers = document.querySelectorAll('[data-market-switcher]');
  switchers.forEach(function(switcher) {
    var toggle = switcher.querySelector('.market-switcher__toggle');
    var dropdown = switcher.querySelector('.market-switcher__dropdown');
    if (!toggle || !dropdown) return;

    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (isOpen) {
        dropdown.setAttribute('hidden', '');
      } else {
        dropdown.removeAttribute('hidden');
      }
    });
  });

  document.addEventListener('click', function(e) {
    switchers.forEach(function(switcher) {
      var toggle = switcher.querySelector('.market-switcher__toggle');
      var dropdown = switcher.querySelector('.market-switcher__dropdown');
      if (!switcher.contains(e.target)) {
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('hidden', '');
      }
    });
  });
})();